import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=6a33f36c&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=6a33f36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33f36c",
  null
  
)

export default component.exports